import React from 'react';
import { Fab } from '@biq/apex-ui';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { SystemWalletIcon } from '../../assets';
import { WALLETS_AND_GROUPS_PATHS } from '../../constants/wallets-and-groups-paths';
import { emptyStateStyles } from './elevate-system-wallet-empty-state-helper';

export const ElevateSystemWalletEmptyState = (): React.JSX.Element => {
    const navigate = useNavigate();

    const handleAddWalletButtonClick = (): void => {
        navigate(`${WALLETS_AND_GROUPS_PATHS.WALLETS_AND_GROUPS_PATH}`);
    };

    return (
        <Grid sx={emptyStateStyles.mainContainer}>
            <img
                src={SystemWalletIcon}
                alt='system-wallet-empty-state-icon'
                style={emptyStateStyles.image}
            />
            <Typography sx={emptyStateStyles.title}>
                You don&#39;t have any system wallets.
            </Typography>
            <Typography sx={emptyStateStyles.subtitle}>
                Create a system wallet to begin elevating.
            </Typography>
            <Fab
                type='button'
                sx={emptyStateStyles.createButton}
                icon={<RefreshIcon />}
                color='secondary'
                label='CREATE WALLET'
                onClick={handleAddWalletButtonClick}
            />
        </Grid>
    );
};
